import axios from 'axios';

// The validation endpoint is on actservices, which lives on a DIFFERENT HOST
// from actdispatcher (e.g. qa.actservices.allcityapp.com vs
// qa.actdispatcherapi.allcityapp.com). Driving this from a dedicated env var
// instead of string-replacing the dispatcher URL — that host swap was the
// source of the 404 preflight in QA.
const SERVICES_BASEURL =
  process.env.REACT_APP_SERVICES_BASE_URL ||
  'https://qa.actservices.allcityapp.com/actservicesapi/';

/**
 * Validates an address using the backend Address Validation API (Google Address Validation).
 *
 * @param {string} addressLine1
 * @param {string} city
 * @param {string} state
 * @param {string} zipcode
 * @returns {Promise<{verified: boolean, confidence: string, standardizedAddress: string}>}
 */
export async function validateAddress(addressLine1, city, state, zipcode) {
  try {
    if (!addressLine1 || addressLine1.trim() === '') {
      return { verified: false, confidence: 'UNCONFIRMED', standardizedAddress: '' };
    }

    const url = SERVICES_BASEURL + 'addressVerification/validate';
    // appId is the static header the actservices @RequestMapping requires
    // (kept consistent with /addressVerification/getMatch). The endpoint is
    // unauthenticated for the officer app and instead enforces an Origin /
    // Referer check restricted to *.allcityapp.com on the server side.
    const response = await axios.post(url, { addressLine1, city, state, zipcode }, {
      headers: { appId: 'AQWS1234' }
    });

    if (response.data) {
      return {
        verified: response.data.verified || false,
        confidence: response.data.confidence || 'UNCONFIRMED',
        standardizedAddress: response.data.standardizedAddress || ''
      };
    }

    return { verified: false, confidence: 'UNCONFIRMED', standardizedAddress: '' };
  } catch (error) {
    console.error('Address validation failed:', error);
    return { verified: false, confidence: 'ERROR', standardizedAddress: '' };
  }
}
